// extracted by mini-css-extract-plugin
export var externalLink = "_ar-0";
export var internalLinkLabel = "_ar-1";